import { DirectiveOptions } from 'vue';
import 'intersection-observer'; // pollyfill做个兼容
import reportBi from './report';
/*
 * 元素或产品曝光上报指令封装，元素进入可视视窗即为曝光
 */
const io = new IntersectionObserver((entries) => {
  // console.log('entries',entries)
  entries.forEach((item) => {
    // 触发时不完全等于1，可能为0.99这种小数，所以*10后比较整数部分
    if (item.intersectionRatio * 10 > 9) {
      reportBi('brow', item.target);
    }
  });
}, {
  // root: document.querySelector('body'),
  threshold: [0.9], // 90%全部显示视为进入可视区
});
const directive: DirectiveOptions = {
  inserted(el) {
    io.unobserve(el);// 先释放，再监听，防止重复监听
    io.observe(el);
  },
  componentUpdated(el) {
    io.unobserve(el);// 先释放，再监听，防止重复监听
    io.observe(el);
  },
};
export default directive;
